import { apiInstance } from '@/api/api.js'

const api = apiInstance()

export default {
  async getAdminOperations({ commit }, params) {
    commit('setLoading', true)
    try {
      const response = await api.get('/auditable/operations', { params })

      // commit('setPatientsFilters', params)
      commit('setAdminOperations', response.data.content)
      commit('setPagination', response.data.pageMetadata)

    } catch (error) {
      console.error(error)
    } finally {
      commit('setLoading', false)
    }
  },
  async getAdminLogs({ commit }, traceId) {
    commit('setLoading', true)
    try {
      const response = await api.get(`/auditable/database-logs?traceId=${traceId}`)
      commit('setAdminLogs', response.data.content)
    } catch (error) {
      console.error(error)
      commit('appStates/setSnackbarNotification', 'Please try again!', {
        root: true,
      })
    } finally {
      commit('setLoading', false)
    }
  }
}
